import { CANCEL_REDIRECT, PROFILE_CHANGE_REQUEST, PROFILE_CHANGE_REQUEST_ERROR, PROFILE_CHANGE_REQUEST_SUCCESS } from './Constants';

// userReducer.js
const initialState = {
    loading: false,
    error: null,
};
  
export const myProfileReducer = (state = initialState, action) => {
    switch (action.type) {
    case PROFILE_CHANGE_REQUEST:        
        return { ...state, payload : action.payload, loading: true };
    case PROFILE_CHANGE_REQUEST_SUCCESS :                
        return { ...state, successMsg : action.msg, loading: false };
    case PROFILE_CHANGE_REQUEST_ERROR :
        return { ...state,loading: false };
    case CANCEL_REDIRECT :        
        return { ...state, successMsg : action.msg, loading: false };
    default:
        return state;
    }
};
  